import PropTypes from "prop-types";

import "../../styles/Updates.scss";

/**
 * This is the Timeline component on school admin homepage
 * @name Timeline
 * @returns {JSX.Element}
 */
const Updates = ({ loader, status, statusClass, timePeriodDto }) => {
    return (
        <div className="school-section-container">
            <div className="sub-section-title">
                Updates{" "}
                {!loader && timePeriodDto ? (
                    <div className={`status-box ${statusClass}`}>Template Status: {status}</div>
                ) : (
                    <div style={{ height: "24px" }} />
                )}
            </div>

            <div className="sub-section-line" />

            <div className="school-updates-container">
                <div className="updates-text">
                    <b> 🎉 New Feature:</b> It is now possible to interact with a teacher&apos;s homeroom Report Card by
                    clicking on their name from the Report Card Overview. This functionality allows a building
                    administrator to act on behalf of a teacher in a few important ways: modify student ratings and
                    comments, add/remove shares and queue the semester Report Card for release to parents/guardians. As
                    a best practice, please advise the teacher of any actions you are taking on their behalf (as
                    appropriate) that substantively change their entered work.
                </div>
            </div>
        </div>
    );
};

Updates.propTypes = {
    loader: PropTypes.bool,
    status: PropTypes.string,
    statusClass: PropTypes.string,
    timePeriodDto: PropTypes.instanceOf(Array)
};

export default Updates;
